import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'unsafe',
    standalone: true,
})
export class UnsafePipe implements PipeTransform {
    readonly #sanitizer = inject(DomSanitizer);

    transform(html: string): SafeHtml {
        return this.#sanitizer.bypassSecurityTrustHtml(html);
    }
}
